import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Pipeline from "@/pages/Pipeline";
import IdeaDetail from "@/pages/IdeaDetail";
import DecisionLog from "@/pages/DecisionLog";
import Analytics from "@/pages/Analytics";
import ParkRegister from "@/pages/ParkRegister";
import Rubrics from "@/pages/Rubrics";
import Notifications from "@/pages/Notifications";
import Team from "@/pages/Team";
import Readiness from "@/pages/Readiness";
import Process from "@/pages/Process";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Pipeline />} />
              <Route path="/ideas/:id" element={<IdeaDetail />} />
              <Route path="/readiness" element={<Readiness />} />
              <Route path="/team" element={<Team />} />
              <Route path="/decisions" element={<DecisionLog />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/register" element={<ParkRegister />} />
              <Route path="/rubrics" element={<Rubrics />} />
              <Route path="/process" element={<Process />} />
              <Route path="/alerts" element={<Notifications />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
